import { Table, Thead, Tbody, Tr, TableContainer, ChakraProvider, Flex, Text } from '@chakra-ui/react'
import { ModalDevolucao } from './DevolucaoTrocaCompra/Modal/ModalDevolucao'
import { useState } from 'react'
import { UsageTh } from './DevolucaoTrocaCompra/Modal/Th'
import { AiOutlineArrowUp } from 'react-icons/ai'
import { useEffect } from 'react'
import DrawerUsage from '../Financeiro/AcompanhaCompras/Drawer/index'
import { UsageTr } from './Tr'
import { useFilterDataOderBy } from '../../hooks/useFilterDataOderBy'

export function TableUsage({
  isProduction = false,
  modalOpen = false,
  isAcompanhaCompras = false,
  isRecebimentoMateriais = false,
  isCompra = false,
  infos,
  atualizaPendenciaEtiqueta,
  setLoading,
  submitForm,
  pegarObservacao,
  dadosObservacoes,
  setOpen,
  open,
  handleOpenModal,
  updateStatusAcompanhaCompras,
  arrayAprova,
  setArrayAprova,
  setNunota,
  nunota,
  setCodProd,
  codProd,
  setSequencia,
  sequencia,
  handleOrderBy,
}) {
  const [dataModal, setDataModal] = useState(0)
  const [obsFornecedor, setObsFornecedor] = useState('')
  const [dadosModal, setDadosModal] = useState({})
  const [dadosDrawer, setDadosDrawer] = useState({})
  const [tableHeight, setTableHeight] = useState(0)
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [drawerDescription, setDrawerDescription] = useState('')

  const [fotoView, setFotoView] = useState({
    foto1: false,
    foto2: false,
    foto3: false,
  })

  function pendencias(pendencia) {
    const pendencias = {
      Pendente: 'red',
      Concluído: 'green',
      S: '#eead2d',
      N: 'green',
      A: 'red',
    }

    if (pendencias[pendencia]) {
      return pendencias[pendencia]
    }

    return '#eead2d'
  }

  function checkOrRemoveCheck(pedVenda, numero_nota, cod_prod, seq, checked) {
    if (checked) {
      setArrayAprova([...arrayAprova, pedVenda])
      setNunota([...nunota, numero_nota])
      setCodProd([...codProd, cod_prod])
      setSequencia([...sequencia, seq])
    } else {
      const newArray = arrayAprova.filter((item) => item !== pedVenda)
      const newArrayNunota = nunota.filter((item) => item !== numero_nota)
      const newArrayCodProd = codProd.filter((item) => item !== cod_prod)
      const newArraySequencia = sequencia.filter((item) => item !== seq)

      setArrayAprova(newArray)
      setNunota(newArrayNunota)
      setCodProd(newArrayCodProd)
      setSequencia(newArraySequencia)
    }
  }

  const { newerOrOlder, setNewerOrOlder } = useFilterDataOderBy(infos, 'data_saida_mercadoria')
  const { newerOrOlder: orderCompra, setNewerOrOlder: setNewerOrOlderCompra } = useFilterDataOderBy(infos, 'data_compra')

  let variableDependence = window.innerHeight || 0

  useEffect(() => {
    setTableHeight(window.innerHeight)
  }, [variableDependence])

  return (
    <ChakraProvider>
      <TableContainer textAlign="center" height={window.innerHeight - (isAcompanhaCompras ? 200 : 300) + 'px'} overflowY="auto" overFlowX="auto">
        <ModalDevolucao
          w="100%"
          open={open}
          onClose={handleOpenModal}
          dataModal={dataModal}
          modalOpen={modalOpen}
          fotoView={fotoView}
          setFotoView={setFotoView}
          obsFornecedor={obsFornecedor}
          dadosModal={dadosModal}
          dadosObservacoes={dadosObservacoes}
          submitForm={submitForm}
        />
        <DrawerUsage open={drawerOpen} setOpen={setDrawerOpen} nunota={dataModal} submitForm={submitForm} />
        <DrawerUsage open={drawerDescription} setOpen={setDrawerDescription} nunota={dataModal} dadosDrawer={dadosDrawer} description />
        <Table variant="striped" colorScheme="gray" fontSize="0.7rem">
          <Thead textAlign="center" px="6rem" position="sticky" top="0" zIndex="1">
            <Tr bg="#378BBF" color="white" mx="6rem">
              {/* {!!isAcompanhaCompras && <UsageTh text="Pedido" />} */}
              {!!isAcompanhaCompras && <UsageTh text="PED VENDA" />}
              {!isAcompanhaCompras && !isRecebimentoMateriais && <UsageTh text="N. Ped XBZ" />}
              <UsageTh text={!isAcompanhaCompras ? 'Data do pedido' : 'Aprov Cliente'} isAcompanhaCompras={isAcompanhaCompras} />
              {!isAcompanhaCompras && <UsageTh text={'Data de Devolução'} isAcompanhaCompras={isAcompanhaCompras} />}
              {/* {!!isAcompanhaCompras && <UsageTh text="Data de saída" />} */}
              <UsageTh
                text={
                  !isAcompanhaCompras ? (
                    'Pedido Venda'
                  ) : (
                    <Flex alignItems="center">
                      <Text>Ped Compra</Text>
                      <Flex ml="1rem" justifyContent="center" alignItems="center" cursor="pointer">
                        <Flex
                          transform={orderCompra === 'newer' ? 'rotate(180deg)' : ''}
                          transition="all .3s ease-in-out"
                          borderRadius="50%"
                          padding="0.2rem"
                          justifyContent="center"
                          alignItems="center"
                          border="1px solid white"
                          bgColor="transparent"
                          onClick={() => {
                            orderCompra === 'newer' ? setNewerOrOlderCompra('older') : setNewerOrOlderCompra('newer')
                          }}
                        >
                          <AiOutlineArrowUp size="1rem" />
                        </Flex>
                      </Flex>
                    </Flex>
                  )
                }
                isAcompanhaCompras={isAcompanhaCompras}
              />
              <UsageTh text="Forn" isAcompanhaCompras={isAcompanhaCompras} />
              {!isAcompanhaCompras && <UsageTh text="Cód. Innovation" />}
              <UsageTh text="Descrição" isAcompanhaCompras={isAcompanhaCompras} />
              {!!isAcompanhaCompras && <UsageTh text="Cod. Prod" isAcompanhaCompras={isAcompanhaCompras} />}
              <UsageTh text="Cor do PROD" isAcompanhaCompras={isAcompanhaCompras} />
              {/* {!!isAcompanhaCompras && <UsageTh text="Cod. Parc. Forn" />} */}
              <UsageTh text="Cód. Forn" isAcompanhaCompras={isAcompanhaCompras} />
              <UsageTh text="QTD" isAcompanhaCompras={isAcompanhaCompras} />
              {!isRecebimentoMateriais && (
                <UsageTh isRecebimentoMateriais text="Limite Produção" newerOrOlder={newerOrOlder} setNewerOrOlder={setNewerOrOlder} />
              )}
              {!!isRecebimentoMateriais && (
                <UsageTh
                  isRecebimentoMateriais={isRecebimentoMateriais}
                  text="Data Limite de Produção"
                  newerOrOlder={newerOrOlder}
                  setNewerOrOlder={setNewerOrOlder}
                />
              )}
              {!!isAcompanhaCompras && !isRecebimentoMateriais && <UsageTh text="Data chegou" isAcompanhaCompras={isAcompanhaCompras} />}
              {!!isAcompanhaCompras && !isRecebimentoMateriais && <UsageTh text="Link Layout" isAcompanhaCompras={isAcompanhaCompras} />}
              {!isAcompanhaCompras && <UsageTh text="Status" />}
              {!!isProduction && <UsageTh />}
              {!!isProduction && <UsageTh />}
              {!!isAcompanhaCompras && !isRecebimentoMateriais && <UsageTh text="Status Recebimento" isAcompanhaCompras={isAcompanhaCompras} />}
              {!!isAcompanhaCompras && <UsageTh text="Pendência" isAcompanhaCompras={isAcompanhaCompras} />}
              {!!isAcompanhaCompras && <UsageTh text="Xbz" />}

              {!!isRecebimentoMateriais && <UsageTh text="Validar" isAcompanhaCompras={isAcompanhaCompras} />}
              {/* {!!isRecebimentoMateriais && (
                <UsageTh text="Confirmar" isAcompanhaCompras={isAcompanhaCompras} />
              )} */}
              {!!isCompra && <UsageTh text="Deletar" />}
            </Tr>
          </Thead>
          <Tbody>
            {infos?.map((item) =>
              !!isAcompanhaCompras && Number(item.dias_prazo_compra) >= 2 && Number(item.dias_prazo_compra) <= 4 ? (
                <UsageTr
                  item={item}
                  isAcompanhaCompras={isAcompanhaCompras}
                  isProduction={isProduction}
                  setDataModal={setDataModal}
                  setObsFornecedor={setObsFornecedor}
                  pegarObservacao={pegarObservacao}
                  setDadosModal={setDadosModal}
                  setDrawerOpen={setDrawerOpen}
                  setDrawerDescription={setDrawerDescription}
                  setDadosDrawer={setDadosDrawer}
                  atualizaPendenciaEtiqueta={atualizaPendenciaEtiqueta}
                  pendencias={pendencias}
                  submitForm={submitForm}
                  checkOrRemoveCheck={checkOrRemoveCheck}
                  isRecebimentoMateriais={isRecebimentoMateriais}
                  isCompra={isCompra}
                />
              ) : item.pendente !== 'S' && item.dias_prazo_compra > 0 ? (
                <UsageTr
                  item={item}
                  isAcompanhaCompras={isAcompanhaCompras}
                  isProduction={isProduction}
                  setDataModal={setDataModal}
                  setObsFornecedor={setObsFornecedor}
                  pegarObservacao={pegarObservacao}
                  setDadosModal={setDadosModal}
                  setDrawerOpen={setDrawerOpen}
                  setDrawerDescription={setDrawerDescription}
                  setDadosDrawer={setDadosDrawer}
                  atualizaPendenciaEtiqueta={atualizaPendenciaEtiqueta}
                  pendencias={pendencias}
                  submitForm={submitForm}
                  checkOrRemoveCheck={checkOrRemoveCheck}
                  isRecebimentoMateriais={isRecebimentoMateriais}
                  isCompra={isCompra}
                />
              ) : (
                <UsageTr
                  item={item}
                  isAcompanhaCompras={isAcompanhaCompras}
                  isProduction={isProduction}
                  setDataModal={setDataModal}
                  setObsFornecedor={setObsFornecedor}
                  pegarObservacao={pegarObservacao}
                  setDadosModal={setDadosModal}
                  setDrawerOpen={setDrawerOpen}
                  setDrawerDescription={setDrawerDescription}
                  setDadosDrawer={setDadosDrawer}
                  atualizaPendenciaEtiqueta={atualizaPendenciaEtiqueta}
                  pendencias={pendencias}
                  submitForm={submitForm}
                  checkOrRemoveCheck={checkOrRemoveCheck}
                  isRecebimentoMateriais={isRecebimentoMateriais}
                  setOpen={setOpen}
                  isCompra={isCompra}
                />
              )
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </ChakraProvider>
  )
}
